import { Pipe, PipeTransform } from '@angular/core';
import { Culture, CulturesRequest } from '@ats/api/cm';
import { Apollo, gql } from 'apollo-angular';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

const FILTERED_CULTURE_QUERY = gql`
	query cultures($request: CulturesRequest) {
		cultures(request: $request) {
			id
			name
			label
			winCode
		}
	}
`;

@Pipe({
    name: 'cmCulture',
    standalone: false
})
export class CmCulturePipe implements PipeTransform {
	constructor(private apollo: Apollo) {}

	transform(
		value: string,
		prop: 'name' | 'winCode' = 'winCode',
		filter?: 'neutral' | 'uniqueWinCode'
	): Observable<string> {
		return this.fetchCultures$(filter).pipe(
			map(cultures => cultures.find(culture => culture[prop] === value)?.label)
		);
	}

	private fetchCultures$(filter?: 'neutral' | 'uniqueWinCode') {
		const query = { query: FILTERED_CULTURE_QUERY };
		if (filter) {
			const request: CulturesRequest =
				filter === 'neutral' ? { onlyNeutral: true } : { onlyUniqueWinCodes: true };
			query['request'] = request;
		}

		return this.apollo
			.watchQuery<{ cultures: Partial<Culture>[] }>(query)
			.valueChanges.pipe(map(results => results?.data?.cultures));
	}
}
